<ng-container >
    <div class="whatsapp_template modal-header border-0 d-flex align-items-center justify-content-center position-relative">
        <div><span class="font-semibold text-primary-color">Create Category</span></div>
        <app-svg-icon [name]="'cross'" class="cross-button" (click)="activeModal.dismiss()"></app-svg-icon>
    </div>
    <form class="theme-form" >
        <div class="modal-body mx-2 pb-2">
            <div class="row">
                <div class="col">
                    <app-input 
                    [customClass]="'text-black'"
                    [inputName]="'category'"
                    [inputType]="'text'"
                    [inputId]="'categoryId'"
                    [inputValue]="mastersCategoryModel.categoryName"
                    [inputLabel]="'Category'"
                    (inputValueEmit)="mastersCategoryModel.categoryName = $event"
                    [isRequired]="true">
                    </app-input>
                </div>
                <div class="col">
                    <app-dropdown 
                    [id]="'country'"
                    [labelName]="'Country'"
                    [options]="data?.templateData?.countryDropdown" 
                    (dropdownValueEmit)="mastersCategoryModel.countryId=$event" 
                    [isRequired]="true"
                    >
                    </app-dropdown>
                </div>
            </div> 
            <div class="row py-2 justify-content-center align-items-center">
                <div class="col">
                    <app-checkbox 
                    [status]="mastersCategoryModel.active"
                    [dyanamicId]="'active'"
                    (check)="mastersCategoryModel.active= $event"
                    [checkBoxLabel]="'Active'">
                    </app-checkbox>
                </div>
            </div>
        </div>
      <div class="modal-footer">
        <div class="gap-2 d-flex justify-content-end">
          <app-button [customClass]="'pink_button'" [buttonLabel]="'Clear'" (click)="reset()"></app-button>
          <app-button [customClass]="'primary'" [buttonLabel]="'Save'" (click)="insertUpdateMastersList()"></app-button>
        </div>
      </div>
    </form>
</ng-container>